import React from "react";
import { useSelector } from "types/store";
import Lineage from "components/Lineage/Lineage";
import * as templateReducer from "containers/Templates/reducer";
const TemplateLineage = ({ id }) => {
    const lineage = useSelector((state) => templateReducer.getLineage(state, id));
    return React.createElement(Lineage, { lineage: lineage });
};
export default TemplateLineage;
